import axios from 'axios';
import { ServerError } from 'core';

export async function parseBlobError(error: unknown): Promise<ServerError[]> {
  if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
    try {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      if (Array.isArray(json.error)) {
        return json.error;
      }
    } catch {
      // Failed to parse as JSON
    }
  }
  return [{ message: 'An error occurred while downloading the file.' }];
}
